<template>
  <div class="topic-box"
       :style="{'display': display}" @scroll="topicScroll">
    <div class="topic-header">
      <span @click.stop="openNewTopic">发表</span>
    </div>
    <div v-for="item in resultData.records" :key="item.topicId">
      <topicBar :topic-info="item" @event-topic-click="openTopicInfo"></topicBar>
    </div>
  </div>
</template>

<script>
import topicBar from "@/components/panel/topicBar";
import serviceApi from "@/utils/serviceApi";
import bus from "@/utils/eventBus";

export default {
  name: "topicPage",
  data(){
    return{
      curpage: 1,
      pagesize: 3,
      resultData:{
        total: 0,
        records:[]
      }
    }
  },
  props:{
    isShow: Boolean
  },
  watch:{
    "isShow":{
      handler(newVal, oldVal) {
        if(newVal && !oldVal){
          this.curpage = 1;
          this.resultData.records = [];
          serviceApi.loadTopics(
              {
                curpage: this.curpage,
                pagesize: this.pagesize
              },
              this.callback);
        }
      },
      deep: false,
      immediate: true
    }
  },
  computed:{
    display:function (){
      if(this.isShow){
        return "block"
      }else{
        return "none";
      }
    }
  },
  mounted() {
    serviceApi.loadTopics(
        {
          curpage: this.curpage,
          pagesize: this.pagesize
        },
        this.callback);
  },
  methods:{
    callback: function (resultData){
      this.resultData.total = resultData.total;
      for(let i = 0, len = resultData.records.length; i < len ; i ++){
        this.resultData.records.push(resultData.records[i]);
      }
      this.$emit("event-topic", this.resultData.total)
    },

    openTopicInfo: function (topicInfo){
      bus.emit("openTopicInfo", topicInfo)
    },

    openNewTopic: function (){
      let codeVal = "";
      bus.emit("openNewTopic", codeVal)
    },
    topicScroll: function (e){
      let scrollTop = e.target.scrollTop;
      // 可视区高度
      let clientHeight = e.target.clientHeight;
      // 滚动条总高度
      let scrollHeight = e.target.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight){
        if(Math.ceil(this.resultData.total / this.pagesize) > this.curpage){
            serviceApi.loadTopics(
                  {
                    curpage: this.curpage,
                    pagesize: this.pagesize
                  },
                  this.callback);
            this.curpage = this.curpage + 1;
        }
      }

    }
  },
  components:{
    topicBar
  }
}
</script>

<style scoped>
.topic-box{
  width: calc(100% - 1px);
  height:calc(100% - 1px);
  background-color: #fff;
  overflow-y:auto;
}
.topic-header{
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
}

.topic-header span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: left;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  background-color: #2e7eee;
  color: #fff;
}

</style>
